import React from 'react'
import ReactDOM from 'react-dom'

import './index.css'
import './polyfills'
import 'react-tippy/dist/tippy.css'
import Root from './containers/Root'

import * as Sentry from '@sentry/browser'
import { Integrations as TracingIntegrations } from '@sentry/tracing'
import * as serviceWorker from './serviceWorker'
import { getStage, isLocal } from 'util/env'

ReactDOM.render(<Root />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()

if (!isLocal()) {
  Sentry.init({
    dsn: 'https://3bab07e3ebfe432ba2b3edb4d299075f@sentry.io/1878525',
    environment: getStage(),
    integrations: [new TracingIntegrations.BrowserTracing()],
    tracesSampleRate: 0.2,
  })
}

// Set up hot reloading
if (module.hot) {
  module.hot.accept('./containers/Root', () => {
    const NextRoot = require('./containers/Root').default
    ReactDOM.render(<NextRoot />, document.getElementById('root'))
  })
}
